import React from "react";

import { ApplyContainer, Row, Col, Link } from "./index.style";
import { Container, Title } from "../index.style";
import PlaceHolder from "../../../images/apply.png";

const Apply = () => {
  return (
    <ApplyContainer>
      <Container>
        <Row>
          <Col className="col">
            <img src={PlaceHolder} alt="Let Applicants Easily apply" />
          </Col>
          <Col className="col apply">
            <div>
              <Title>Let Applicants Easily apply</Title>
              <p>
                QuirkyCoders can help remove the barriers between your open
                roles and the talent you need to fill them, with
                <Link href="/employers/post-job">QuirkyCoders Apply</Link>
              </p>

              <p>
                Also, when job seekers can easily apply on any device, including
                mobile, employers get up to 4X as many applicants. Interested in
                learning more about hiring online with mobile recruiting?<br />
                <br />
                <Link href="/contact-us">
                  Learn more about your mobile recruiting options.
                </Link>
              </p>
              <p className="source">Source: QuirkyCoders data (worldwide)</p>
            </div>
          </Col>
        </Row>
      </Container>
    </ApplyContainer>
  );
};

export default Apply;
